module.exports = __webpack_public_path__ + "static/oaken-logo-dd1918160ee7fd57af4daf6bd4c12046.png";